<template>
  <v-footer
    dark
    padless
  >
    <v-card
      flat
      tile
      width="100%" 
      class="grey darken-3 white--text text-center"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon.icon"
          class="mx-4 white--text"
          icon
          :href="icon.link"
        >
          <v-icon size="24px">
            {{ icon.icon }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0 " >
       Luta pelos teus sonhos, só tu os consegues concretizar!
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text  class="white--text">
        {{ new Date().getFullYear() }} — <strong>Nídia Natal</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data() {
      return {
        icons: [
        {icon: 'mdi-facebook', link: 'https://www.facebook.com/N%C3%ADdia-Natal-110564448177043'},
        {icon: 'mdi-instagram', link: 'https://www.instagram.com/nidia__natal'},
        {icon: 'mdi-book-open-page-variant-outline', link: 'https://medium.com/@NidiaNatal'},
        {icon: 'mdi-shopping', link: 'https://niarte-funchal.com'}     
      ],
      }
    }
  }
</script>
<style scoped>

.full_size { 
  min-width: 1500px;
}

</style>